// services/track/trackVideoEvent.ts
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";
import { AxiosError } from "axios";

export type TrackFileType = "video" | "audio" | "pdf";

export interface TrackMediaPayload {
  userid: number;
  courseid: string;
  filetype: "video" | "audio";
  videoid: string;
  eventtype: string;
  playtime: number;
}

export interface TrackPdfPayload {
  userid: number;
  courseid: string;
  filetype: "pdf";
  pdfid: string;
  isseen: any;
}

export type TrackVideoPayload = TrackMediaPayload | TrackPdfPayload;

export const trackVideoEvent = async (payload: TrackVideoPayload) => {
  try {
    const params =
      payload.filetype === "pdf"
        ? {
            wsfunction: "local_learning_progress_track_event",
            userid: payload.userid,
            courseid: payload.courseid,
            filetype: payload.filetype,
            pdfid: payload.pdfid,
            isseen: payload.isseen,
          }
        : {
            wsfunction: "local_learning_progress_track_event",
            userid: payload.userid,
            courseid: payload.courseid,
            filetype: payload.filetype,
            videoid: payload.videoid,
            eventtype: payload.eventtype,
            playtime: payload.playtime,
          };

    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      { params }
    );
    return response?.data;
  } catch (error) {
    // console.error('API Error:', error);
    return handleApiError(error as AxiosError);
  }
};

export const getAllTrackVideo = async (payload: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_learning_progress_get_all_by_user",
          userid: payload.userid,
          courseid: payload.courseid,
        },
      }
    );
    return response?.data;
  } catch (error) {
    // console.error('API Error:', error);
    return handleApiError(error as AxiosError);
  }
};
